var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50646 19.4871C6.09215 19.4871 5.7375 19.3396 5.4425 19.0446C5.1475 18.7496 5 18.3949 5 17.9806V6.82687C5 6.41257 5.1475 6.05792 5.4425 5.76292C5.7375 5.46792 6.09215 5.32042 6.50646 5.32042H13.75V6.57042H6.50646C6.4316 6.57042 6.37014 6.59444 6.32208 6.6425C6.27403 6.69056 6.25 6.75201 6.25 6.82687V17.9806C6.25 18.0555 6.27403 18.1169 6.32208 18.165C6.37014 18.2131 6.4316 18.2371 6.50646 18.2371H17.6602C17.7349 18.2371 17.7964 18.2131 17.8446 18.165C17.8926 18.1169 17.9167 18.0555 17.9167 17.9806V10.7371H19.1667V17.9806C19.1667 18.3949 19.0192 18.7496 18.7242 19.0446C18.4292 19.3396 18.0745 19.4871 17.6602 19.4871H6.50646ZM16.5704 9.58312V7.91646H14.9038V6.66667H16.5704V5H17.8204V6.66667H19.4871V7.91646H17.8204V9.58312H16.5704ZM7.70833 16.3621H16.5223L13.7819 12.7083L11.4423 15.7531L9.77563 13.6217L7.70833 16.3621Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.252d8f1e1f19ea38f69d1ba3c1ded612.svg";
export { ForwardRef as ReactComponent };